import { Controller } from '@hotwired/stimulus';
import { each, extend, noop } from 'lodash';

const SPAIN = '73';

// Componente para gestionar los inputs de Pais, Provincia, Municipio etc.
// Se encarga de gestionar la carga de los combos y mostrar/ocultar los
// campos seleccionables o lo s de libre escritura (los provincia_dn, etc)
/* global Mn, Cifra, $ */
const LocalizacionView = Mn.View.extend({
  template: noop,
  ui: {
    pais: "[name*='pais_id']",
    provincia_id: "[name*='provincia_id']",
    provincia_dn: "[name*='provincia_dn']",
    municipio_id: "[name*='municipio_id']",
    municipio_dn: "[name*='municipio_dn']",
    localidad_id: "[name*='localidad_id']",
    localidad_dn: "[name*='localidad_dn']",
  },
  events: {
    'change @ui.pais': 'actualizarVisibilidad',
    'change @ui.provincia_id': 'cargarMunicipios',
  },
  initialize() {
    this.municipios = new Cifra.Collections.Municipios();
    this.localidades = new Cifra.Collections.Localidades();
  },
  onRender() {
    const view = this;
    this.actualizarVisibilidad();
    new Cifra.Components.Select({
      el: this.getUI('municipio_id'),
      collection: this.municipios,
      showEmpty: true,
      onChange() {
        view.cargarLocalidades();
      },
    }).render();
    new Cifra.Components.Select({
      el: this.getUI('localidad_id'),
      collection: this.localidades,
      showEmpty: true,
    }).render();

    // Primera carga de los municipios que ella misma provocará
    // la carga de las localidades
    this.cargarMunicipios();
  },
  cargarMunicipios() {
    const view = this;
    this.municipios.fetch({
      data: { provincia_id: this.getUI('provincia_id').val() },
    }).done(() => {
      view.cargarLocalidades();
    });
  },
  cargarLocalidades() {
    this.localidades.fetch({
      data: { municipio_id: this.getUI('municipio_id').val() },
    });
  },
  actualizarVisibilidad() {
    const $pais = this.getUI('pais');
    this.showPorNombre($pais.val() !== SPAIN);
    this.showPorSelects($pais.val() === SPAIN);
  },
  showPorNombre(show) {
    const view = this;
    each(['provincia_dn', 'municipio_dn', 'localidad_dn'], (campo) => {
      const $input = view.getUI(campo);
      $input.closest('.form-group').toggle(show);
      if (!show) {
        $input.val('');
      }
    });
  },
  showPorSelects(show) {
    const view = this;
    each(['provincia_id', 'municipio_id', 'localidad_id'], (campo) => {
      view.getUI(campo).closest('.form-group').toggle(show);
    });
    if (!show) {
      view.getUI('municipio_id').find('option').remove();
      view.getUI('localidad_id').find('option').remove();
    }
  },
});

export default class extends Controller {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new LocalizacionView(options);
    this.component.render();
  }

  render() {
    this.component.render();
  }
}
